import React, { useEffect, useState } from 'react';
import Barcode from 'react-barcode'; // react-barcodeをインポート
import { useAuthenticator } from '@aws-amplify/ui-react';
import './BarcodePage.css'; // カスタムCSSをインポート
import { Button } from '@mui/material'; // MUIのButtonコンポーネントをインポート
import { useNavigate } from 'react-router-dom'; // useNavigateをインポート

function BarcodePage() {
  const { user } = useAuthenticator((context) => [context.user]); // useAuthenticatorでユーザー情報を取得
  const [customerCode, setCustomerCode] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // ローカルストレージから会員コードを取得
    const localCustomerCode = localStorage.getItem('customerCode');
    if (localCustomerCode) {
      setCustomerCode(localCustomerCode);
    } else {
      console.warn('No customerCode found in localStorage');
    }
  }, []);

  const handleNavigateHome = () => {
    navigate('/');
  };

  return (
    <div style={{ textAlign: 'center', padding: '20px 0' }}>
      <h2 style={{fontSize: '3em', padding:'0px'}}>{user?.username || user?.attributes?.email || 'Guest'}</h2>
      <p style={{ color: 'gray' }}>ID: {customerCode || 'N/A'}</p>
      {customerCode ? (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%', overflow: 'hidden' }}>
          <div className="barcode-container">
            <Barcode value={customerCode} format="CODE128" width={1.2} />
          </div>
        </div>
      ) : (
        <p>No customer code available to display</p>
      )}
      <p>お会計時に左下の会員アイコンをタップし</p>
      <p>バーコードリーダーにかざしてください</p>
      <Button 
        variant="contained" 
        color="primary" 
        onClick={handleNavigateHome} 
        sx={{ marginTop: '20px' }}
      >
        Homeに戻る
      </Button>
    </div>
  );
}

export default BarcodePage;
